import { react, git, mongo, nodeJS, material, gcloud, bootstrap, figma, html, css, js, styled, router, express, vscode, npm, tailwind, nextjs, ts, momentjs, copilot, chatgpt, vercel, pup } from 'img'

export const stack = {
    header: 'What I Use',
    PolishLang: {
        header: 'Czego Używam',
    },
    tools: [
        {
            img: ts,
            title: "TypeScript",
            text: "TypeScript",
            webHref: "https://www.typescriptlang.org/docs/",
        }, {
            img: tailwind,
            title: "Tailwind",
            text: "",
            webHref: "https://developer.mozilla.org/en-US/docs/Web/HTML",
        }, {
            img: html,
            title: "HTML",
            text: "",
            webHref: "https://developer.mozilla.org/en-US/docs/Web/HTML",
        }, {
            img: nextjs,
            title: "Next js",
            text: "",
            webHref: "https://developer.mozilla.org/en-US/docs/Web/HTML",
        }, {
            img: css,
            title: "CSS",
            text: "",
            webHref: "https://www.w3.org/Style/CSS/Overview.en.html",
        }
        , {
            img: js,
            title: "JavaScript",
            text: "",
            webHref: "https://javascript.info/",
        }, {
            img: npm,
            title: "NPM",
            text: "",
            webHref: "https://www.npmjs.com/",
        }, {
            img: react,
            title: "React",
            text: "React makes it painless to create interactive UIs. Design simple views...",
            webHref: "https://reactjs.org/",
        }, {
            img: styled,
            title: "Styled..",
            text: "",
            webHref: "https://styled-components.com/",
            styled: true
        }, {
            img: router,
            title: "React-Router",
            text: "",
            webHref: "https://reactrouter.com/",
        }, {
            img: bootstrap,
            title: "Bootstarp",
            text: "Quickly design and customize responsive mobile-first sites with Bootst...",
            webHref: "https://getbootstrap.com",
        }, {
            img: material,
            title: "Material-UI",
            text: "Material-UI is an open-source project that features React components t...",
            webHref: "https://material-ui.com/",
        }, {
            img: figma,
            title: "Figma",
            text: "Figma is a browser-based UI and UX design application, with excellent ...",
            webHref: "https://www.figma.com/",
        }, {
            img: gcloud,
            title: "Google Cloud",
            text: "Google Cloud Platform is a suite of public cloud computing services of...",
            webHref: "https://cloud.google.com/",
        }, {
            img: momentjs,
            title: "Momentsjs",
            text: "Parse, validate, manipulate, and display dates and times in JavaScript.",
            webHref: "https://momentjs.com/",
        }, {
            img: nodeJS,
            title: "NodeJs",
            text: "Node.Js (Node) is an open source development platform for executing Ja...",
            webHref: "https://nodejs.org/en/",
        }, {
            img: express,
            title: "Express.js",
            text: "",
            webHref: "https://expressjs.com/",
        }, {
            img: mongo,
            title: "MongoDB",
            text: "MongoDB is a cross-platform and open-source document-oriented database...",
            webHref: "https://www.mongodb.com/",
        }, {
            img: git,
            title: "GitHub",
            text: "GitHub is a Git repository hosting service, but it adds many of its ow...",
            webHref: "https://github.com/",
        }, {
            img: vscode,
            title: "VS Code",
            text: "",
            webHref: "https://code.visualstudio.com/",
        }, {
            img: chatgpt,
            title: "ChatGPT",
            text: "",
            webHref: "https://chatgpt.com/",
        }, {
            img: copilot,
            title: "Copilot",
            text: "",
            webHref: "https://copilot.microsoft.com/",
        }, {
            img: vercel,
            title: "Vercel",
            text: "",
            webHref: "https://ubuntu.com/",
        },
        {
            img: pup,
            title: "Puppeteer",
            text: "",
            webHref: "https://pptr.dev/",
        },
        // {
        //     img: python,
        //     title: "Python",
        //     text: "",
        //     webHref: "https://www.python.org/",
        // }, 


    ]
}